<div class="flex flex-col gap-y-8 h-full">
  <parkour-page-gradient />

  <div class="relative z-10 flex flex-col py-8 container container-space gap-y-8">
    <div class="flex flex-col items-center text-center gap-y-4 container-1-col">
      <h1>{{ uitnodiging.naam }}</h1>
      <p class="text-n-600">{{ uitnodiging.rol | rolLabel }}</p>
      <parkour-divider />
    </div>

    <div class="container-1-col">
      <parkour-info-card class="block mb-2">
        <p>
          @if (uitnodiging.status === 'GEWEIGERD') {
            {{ 'team.uitnodiging.geweigerd-status' | translate }}
          } @else {
            {{ 'team.uitnodiging.niet-aanvaard-status' | translate }}
          }
        </p>
      </parkour-info-card>

      <div class="flex flex-col gap-y-4 bg-n-200 rounded p-4">
        <div>
          <p class="font-medium mb-1">{{ 'team.uitnodiging.uitgenodigd-op' | translate }}</p>
          <p>{{ uitnodiging.aangemaaktOpTijdstip | date }}</p>
        </div>

        @if (uitnodiging.email) {
          <div>
            <p class="font-medium">{{ 'team.uitnodiging.uitgenodigd-via-email' | translate }}</p>
            <p>{{ uitnodiging.email }}</p>
          </div>
        }

        @if (uitnodiging.mobielNummer) {
          <div>
            <p class="font-medium">{{ 'team.uitnodiging.uitgenodigd-via-sms' | translate }}</p>
            <p>{{ uitnodiging.mobielNummer }}</p>
          </div>
        }

        @if (!uitnodiging.email && !uitnodiging.mobielNummer) {
          <div>
            <p class="typo-body">Uitgenodigd via QR code</p>
            <!-- TODO: UX Copy QR aan JSON toevoegen -->
          </div>
        }
      </div>
    </div>
  </div>

  @if (uitnodiging.status !== 'GEWEIGERD') {
    <div class="mt-auto bg-n-200 p-4 pt-6">
      <div class="container-1-col flex flex-col gap-y-4">
        <h2 class="typo-h3">{{ 'team.uitnodiging.stopzetten-title' | translate }}</h2>
        <p>{{ 'team.uitnodiging.stopzetten-description' | translate }}</p>

        <parkour-button
          (clicked)="onVerwijderUitnodiging()"
          class="w-full mb-10"
          iconAfter="trash"
          variant="tertiary"
        >
          {{ 'team.uitnodiging.stopzetten-button' | translate }}
        </parkour-button>
      </div>
    </div>
  }
</div>
